<template>
    <div :class="$style['goods-order-states']">
        <wt-steps :steps="steps" :alignCenter="true" :active="stepsActive" stepTitle="name" description="happen_time"></wt-steps>
    </div>
</template>
<script>
export default {
  props: {
    steps: {
      type: Array,
      default: function () {
        return []
      }
    },
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      stepsActive: 0
    }
  },
  watch: {
    steps: {
      handler: function (val) {
        val.forEach(item => {
          if (item.completed) {
            this.stepsActive = this.stepsActive + 1
          }
        })
      },
      deep: true
    }
  }
}
</script>
<style module lang="less">
.goods-order-states{
    padding: 20px 0;
}
</style>
